import * as Yup from 'yup';

const hasText = (value: string | undefined) => !!value?.trim();

/*
    What the server already refuses, checked here so an admin sees it beside the field instead of in
    a failure message after a long save.

    One server rule is not here. Playlist#description is required once the playlist is published,
    unless it is a capstone, and `capstone` is not in ADMIN_FIELDS. The client cannot tell the two
    apart, so that failure stays a save-time error.
*/
export const validationSchema = Yup.object().shape(
    {
        title: Yup.string().trim().required('A playlist needs a title.'),

        // Playlist::LocalePack#validate_course_code wants both or neither.
        course_code_prefix: Yup.string().when('course_code', {
            is: hasText,
            then: schema => schema.trim().required('A course code needs a course code prefix.'),
        }),

        course_code: Yup.string().when('course_code_prefix', {
            is: hasText,
            then: schema => schema.trim().required('A course code prefix needs a course code.'),
        }),

        // The input holds a string, so these are tests rather than Yup.number().
        hours_of_credit: Yup.string()
            .test('is-a-number', 'Credit hours must be a number.', value => !hasText(value) || !isNaN(Number(value)))
            .test(
                'is-not-negative',
                'Credit hours cannot be negative.',
                value => !hasText(value) || Number(value) >= 0,
            ),
    },

    // The two course code fields each depend on the other, which Yup reads as a cycle unless the
    // pair is declared here.
    [['course_code', 'course_code_prefix']],
);
